<template>
  <v-dialog v-model="dialog" scrollable persistent max-width="1000">
    <v-btn icon slot="activator">
      <v-icon>settings</v-icon>
    </v-btn>
    <v-card v-if="dialog">
      <v-card-title>
        <v-icon color="secondary">layers</v-icon>
        <span>&ensp;</span>
        <span class="secondary--text">
          <strong>{{ items.name }}</strong>
        </span>
      </v-card-title>
      <beacon-list :items="items.beacons" :actions="actions"></beacon-list>
      <v-card-actions>
        <v-btn flat color="secondary" @click.stop="dialog = false">{{ $t('common.close') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn flat color="success" @click.stop="dialog = false">{{ $t('common.ok') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BeaconList from "./BeaconList";

export default {
  props: ["items", "actions"],
  data() {
    return {
      dialog: false
    };
  },
  components: {
    BeaconList,
  }
};
</script>

<style>
</style>
